module.exports = __webpack_public_path__ + "static/assets/62cfab30281b265d9e64dc417c9e9b79.png";